

export const deg2radField = (d) => (d * Math.PI) / 180;
export const rad2degField = (r) => (r * 180) / Math.PI;

export const norm180Field = (d) => {
  let x = d % 360;
  if (x < -180) x += 360;
  if (x > 180) x -= 360;
  return x;
};

/**
 * ------------------------------------------------------------
 * COMPUTE FIELD WIND COMPONENTS
 * ------------------------------------------------------------
 *
 * Inputs:
 * - windDirection: direction wind is coming from
 * - windSpeed: wind speed in knots
 * - runwayHeading: runway heading / takeoff heading
 *
 * Output:
 * - headwind: positive = headwind, negative = tailwind
 * - crosswind: positive = wind from right, negative = wind from left
 */

export const normalizeFtField = (s) => String(s || "").trim().toUpperCase();


export function computeFieldWinds({
    windDirection,
    windSpeed,
    runwayHeading,
}) {

    const WD = Number(windDirection);
    const WS = Number(windSpeed);
    const RH = Number(runwayHeading);

    if (
        !Number.isFinite(WD) ||
        !Number.isFinite(WS) ||
        !Number.isFinite(RH)
    ) {
        return {
            headwind: "",
            crosswind: "",
            headwindLabel: "",
            crosswindLabel: "",
        };
    }

    // ------------------------------------------------------------
    // Wind correction angle
    // ------------------------------------------------------------
    const windAngleDeg = WD - RH;
    const radians = deg2radField(windAngleDeg);

    // ------------------------------------------------------------
    // Headwind and crosswind components
    // ------------------------------------------------------------
    const headwind = WS * Math.cos(radians);
    const crosswind = WS * Math.sin(radians);

    // ------------------------------------------------------------
    // Return computed row
    // ------------------------------------------------------------
    return {
      headwind,
      crosswind,

      headwindLabel:
        headwind >= 0
          ? `Headwind ${headwind.toFixed(0)} kts.`
          : `Tailwind ${Math.abs(headwind).toFixed(0)} kts.`,
      crosswindLabel:
        crosswind >= 0
          ? `Crosswind ${crosswind.toFixed(0)} kts from right.`
          : `Crosswind ${Math.abs(crosswind).toFixed(0)} kts from left.`,

    };
}